"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ItemImage = void 0;
var _mui = require("@ori-ui/mui");
var _checkoutUi = require("@ori/checkout-ui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _models = require("../../models");
var _jsxRuntime = require("react/jsx-runtime");
const Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  backgroundColor: theme.palette.background.default,
  flexShrink: 0,
  height: '100%',
  position: 'absolute',
  width: '100%'
}));
const ItemImage = ({
  isTransparent,
  name,
  onClick,
  productDetailUrl,
  src
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const theme = (0, _mui.useTheme)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Root, {
    "data-testid": getTestId(_models.TestId.ItemImage),
    onClick: onClick,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_checkoutUi.CheckoutImage, {
      component: productDetailUrl ? 'a' : 'span',
      href: productDetailUrl,
      src: src || 'noImage',
      alt: name,
      size: "large",
      background: theme.palette.grey[100],
      opacity: isTransparent ? 0.5 : 1
    })
  });
};
exports.ItemImage = ItemImage;